import { useEffect, useState } from "react";

import { Fab, Zoom } from "@mui/material";

import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

export default function BackToTop() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 400);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Zoom in={showButton}>
      <Fab
        onClick={scrollToTop}
        aria-label="back to top"
        sx={{
          position: "fixed",

          bottom: {
            xs: 20,
            md: 30,
          },

          right: {
            xs: 20,
            md: 30,
          },

          width: {
            xs: 54,
            md: 64,
          },

          height: {
            xs: 54,
            md: 64,
          },

          background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

          color: "#fff",

          border: "2px solid rgba(255,255,255,.5)",

          boxShadow: "0 15px 35px rgba(0,87,255,.30)",

          backdropFilter: "blur(20px)",

          transition: ".35s",

          "&:hover": {
            background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

            transform: "translateY(-5px)",

            boxShadow: "0 25px 50px rgba(0,87,255,.40)",
          },
        }}
      >
        <KeyboardArrowUpIcon
          sx={{
            fontSize: {
              xs: 28,
              md: 34,
            },
          }}
        />
      </Fab>
    </Zoom>
  );
}
